<template>
  <Dashboard grafana-path="/d/PH9K4xqMk/seatbelt-vehicle" />
</template>

<script>
// @ is an alias to /src
import Dashboard from "@/components/Dashboard.vue";

export default {
  name: "SeatbeltVehiclePage",

  routing: {
    localizationKey: "menu.tab.seatbelt_vehicle",
    icon: "mdi-table",
    path: "/seatbelt_vehicle",
    hasAccess: (user) => user.isAdmin || user.isManager,
  },

  components: {
    Dashboard,
  },
};
</script>
